//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import XLSX from 'xlsx'
export default {
  data () {
    return {
      devicesdata: [],
      selections: [], // 列表选中列
      loading: false,
      isImport: false
    }
  },
  methods: {
    importExcel (file, fileList) {
      this.loading = true
      this.isImport = false
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = e => {
          const data = e.target.result
          const fixedData = this.fixdata(data)
          const workbook = XLSX.read(btoa(fixedData), { type: 'base64' })
          const firstSheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[firstSheetName]
          const results = XLSX.utils.sheet_to_json(worksheet)
          let list = results.map(function (item) {
            return {
              Model: item.型号,
              SeriesNO: item.系列号
            }
          })
          this.$api.deviceCheckImport(list).then(res => {
            if (res.Status === 1) {
              this.devicesdata = res.Entity
            } else {
              this.$alert(res.Message, '错误', {
                confirmButtonText: '确定'
              })
            }
          })

          this.loading = false
          resolve()
        }
        reader.readAsArrayBuffer(file.raw)
      })
    },
    fixdata (data) {
      let o = ''
      let l = 0
      const w = 10240
      for (; l < data.byteLength / w; ++l) {
        o += String.fromCharCode.apply(
          null,
          new Uint8Array(data.slice(l * w, l * w + w))
        )
      }
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)))
      return o
    },
    selectionChange: function (selections) {
      this.selections = selections
    },
    handleImport: function () {
      this.$confirm(
        '导入' + this.devicesdata.length.toString() + '个设备信息吗？',
        '提示',
        { cancelButtonClass: 'btn-custom-cancel' }
      ).then(() => {
        this.$api.deviceImport(this.devicesdata).then(res => {
          if (res.Status === 1) {
            this.$message({ message: '导入成功', type: 'success' })
            this.devicesdata = []
          } else {
            this.$alert(res.Message, '错误', {
              confirmButtonText: '确定'
            })
          }
        })
      })
    },
    handleRemove: function () {
      this.$confirm(
        '删除' + this.selections.length.toString() + '个设备吗？',
        '提示',
        { cancelButtonClass: 'btn-custom-cancel' }
      ).then(() => {
        this.selections.forEach(dev => {
          this.devicesdata.splice(this.devicesdata.indexOf(dev), 1)
        })
      })
    },
    tableRowStyle ({ row, rowIndex }) {
      if (row.ErrorMessage !== '') {
        return 'color: red'
      } else {
        return ''
      }
    }
  },
  watch: {
    devicesdata (list) {
      this.isImport = true
      list.forEach(dev => {
        if (dev.ErrorMessage !== '') {
          this.isImport = false
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/admin/ImportDevice.vue